import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
// import relevant API functions here
import { fetchUserList, addUser } from '../../Api/User';
import '../AirportMaster/AirportMaster.css'
import './UserMaster.css'

// Static currency and currency sign API

const getCurrencies = () => [
    { code: "USD", sign: "$" },
    { code: "EUR", sign: "€" },
    { code: "INR", sign: "₹" },
    { code: "GBP", sign: "£" },
    { code: "JPY", sign: "¥" },
    { code: "AUD", sign: "A$" },
    { code: "CAD", sign: "C$" },
    { code: "SGD", sign: "S$" },
    { code: "CHF", sign: "CHF" },
    { code: "CNY", sign: "¥" }
];



const initialForm = {
    UserId: 0,
    Email: '',
    PhoneNumber: '',
    FullName: '',
    AgencyName: '',
    AgencyCode: '',
    Country: '',
    PCCcode: '',
    Currency: '',
    CurrencySign: '',
    IsFixedMarkup: false,
    FixedMarkup: 0,
    IsPercentageMarkup: false,
    PercentageMarkup: 0
};

const UserMaster = () => {
    const [userForm, setUserForm] = useState(initialForm);
    const [showForm, setShowForm] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const [userListRequest, setUserListRequest] = useState({
        PageNo: 1,
        PageSize: 50,
        SortBy: "",
        SearchString: "",
        UserStatus: 1,
        StartDate: "2025-02-26T09:10:34.002Z",
        EndDate: "2026-02-26T09:10:34.003Z"
    });

    const [userList, setUserList] = useState([]);



    useEffect(() => {
        fetchUserList(userListRequest)
            .then(response => {
                setUserList(response.Data || []);
            })
            .catch(error => {
                console.error("Error fetching user list:", error);
            });
    }, [userListRequest]);

    const handleNext = () => {
        setUserListRequest(prev => ({
            ...prev,
            PageNo: prev.PageNo + 1
        }));
    };

    const handlePrev = () => {
        setUserListRequest(prev => ({
            ...prev,
            PageNo: Math.max(prev.PageNo - 1, 1)
        }));
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        // ✅ Currency → auto set CurrencySign
        if (name === "Currency") {
            const selectedCurrency = getCurrencies().find(
                (cur) => cur.code === value
            );

            setUserForm((prev) => ({
                ...prev,
                Currency: value,
                CurrencySign: selectedCurrency ? selectedCurrency.sign : ""
            }));
            return;
        }

        // ✅ All other fields
        setUserForm((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await addUser(userForm).then(response => {
                if (response?.Status === 200) {
                    Swal.fire({
                        title: "Success!",
                        text: isEdit ? "User updated successfully!" : "User added successfully!",
                        icon: "success",
                        confirmButtonText: "OK"
                    }).then(() => {
                        window.location.reload();
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response?.Message || "Something went wrong",
                        icon: "error",
                        confirmButtonText: "OK"
                    });
                }
            }).catch(error => {
                Swal.fire({
                    title: "Error!",
                    text: isEdit ? "Failed to update user" : "Failed to add user",
                    icon: "error",
                    confirmButtonText: "OK"
                });
            });
        } catch (error) {
            Swal.fire({
                title: "Error!",
                text: isEdit ? "Failed to update user" : "Failed to add user",
                icon: "error",
                confirmButtonText: "OK"
            });
        }
        setUserForm(initialForm);
    };

    //   const handleDelete = (userId) => {
    //     Swal.fire({
    //       title: "Are you sure?",
    //       text: "You won't be able to revert this!",
    //       icon: "warning",
    //       showCancelButton: true,
    //       confirmButtonColor: "#3085d6",
    //       cancelButtonColor: "#d33",
    //       confirmButtonText: "Yes, delete it!",
    //       cancelButtonText: "Cancel"
    //     }).then(async (result) => {
    //       if (result.isConfirmed) {
    //         try {
    //           await deleteUser(userId).then(response => {
    //             if (response?.Status === 200) {
    //               Swal.fire({
    //                 title: "Deleted!",
    //                 text: "User deleted successfully!",
    //                 icon: "success",
    //                 confirmButtonText: "OK"
    //               }).then(() => {
    //                 window.location.reload();
    //               });
    //             } else {
    //               Swal.fire({
    //                 title: "Error!",
    //                 text: response?.Message || "Failed to delete user.",
    //                 icon: "error",
    //                 confirmButtonText: "OK"
    //               });
    //             }
    //           }).catch(error => {
    //             Swal.fire({
    //               title: "Error!",
    //               text: "Failed to delete user",
    //               icon: "error",
    //               confirmButtonText: "OK"
    //             });
    //           });
    //         } catch {}
    //       }
    //     });
    //   };

    return (
        <>
            {showForm &&
                <div className="container-fluid bg-white p-4 border mb-4" style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.10)", borderRadius: "16px" }}>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h6 className="section-1-title mb-0 text-start">
                            {isEdit ? "Update User" : "Add User"}
                        </h6>
                        <button
                            type="button"
                            className="btn"
                            onClick={() => setShowForm(false)}
                            title="Close"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                            </svg>
                        </button>
                    </div>

                    <form onSubmit={handleSubmit} >
                        <div className="row g-3">
                            <div className="col-md-3">
                                <input type="email" className="form-control" placeholder="Email" name="Email" value={userForm.Email} onChange={handleChange} />
                            </div>
                            <div className="col-md-3">
                                <input type="text" className="form-control" placeholder="Phone Number" name="PhoneNumber" value={userForm.PhoneNumber} onChange={handleChange} />
                            </div>
                            <div className="col-md-3">
                                <input type="text" className="form-control" placeholder="Full Name" name="FullName" value={userForm.FullName} onChange={handleChange} />
                            </div>
                            <div className="col-md-3">
                                <input type="text" className="form-control" placeholder="Agency Name" name="AgencyName" value={userForm.AgencyName} onChange={handleChange} />
                            </div>
                            <div className="col-md-3">
                                <input type="text" className="form-control" placeholder="Agency Code" name="AgencyCode" value={userForm.AgencyCode} onChange={handleChange} />
                            </div>
                            <div className="col-md-3">
                                <input type="text" className="form-control" placeholder="Country" name="Country" value={userForm.Country} onChange={handleChange} />
                            </div>
                            <div className="col-md-3">
                                <input type="text" className="form-control" placeholder="PCC Code" name="PCCcode" value={userForm.PCCcode} onChange={handleChange} />
                            </div>
                            <div className="col-md-3">
                                <select
                                    className="form-select"
                                    name="Currency"
                                    value={userForm.Currency}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Currency</option>
                                    {getCurrencies().map((cur) => (
                                        <option key={cur.code} value={cur.code}>
                                            {cur.code} - {cur.sign}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Set currency sign in request automatically; removed Currency Sign input */}

                            <div className="col-md-3">
                                <select
                                    className="form-select"
                                    name="MarkupType"
                                    value={
                                        userForm.IsFixedMarkup
                                            ? "Fixed"
                                            : userForm.IsPercentageMarkup
                                            ? "Percentage"
                                            : ""
                                    }
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === "Fixed") {
                                            setUserForm(prev => ({
                                                ...prev,
                                                IsFixedMarkup: true,
                                                IsPercentageMarkup: false,
                                                PercentageMarkup: 0
                                            }));
                                        } else if (value === "Percentage") {
                                            setUserForm(prev => ({
                                                ...prev,
                                                IsFixedMarkup: false,
                                                IsPercentageMarkup: true,
                                                FixedMarkup: 0
                                            }));
                                        } else {
                                            setUserForm(prev => ({
                                                ...prev,
                                                IsFixedMarkup: false,
                                                IsPercentageMarkup: false,
                                                FixedMarkup: 0,
                                                PercentageMarkup: 0
                                            }));
                                        }
                                    }}
                                >
                                    <option value="">Select Markup Type</option>
                                    <option value="Fixed">Fixed Markup</option>
                                    <option value="Percentage">Percentage Markup</option>
                                </select>
                            </div>
                            {userForm.IsFixedMarkup && (
                                <div className="col-md-3">
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Fixed Markup"
                                        name="FixedMarkup"
                                        value={userForm.FixedMarkup}
                                        onChange={handleChange}
                                    />
                                </div>
                            )}
                            {userForm.IsPercentageMarkup && (
                                <div className="col-md-3">
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Percentage Markup"
                                        name="PercentageMarkup"
                                        value={userForm.PercentageMarkup}
                                        onChange={handleChange}
                                    />
                                </div>
                            )}

                            <div className="col-12 mt-3 text-start">
                                <button type="submit" className="Save-btn">
                                    {isEdit ? "Update User" : "Save"}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            }

            <div className="bg-white" style={{ borderRadius: '16px', boxShadow: "0 2px 8px rgba(0,0,0,0.10)" }}>
                {/* Section Header */}
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center p-4 gap-2">
                    <div className="section-1-title align-self-start">
                        User List
                    </div>
                    <div className="d-flex flex-row flex-sm-col gap-2 gap-sm-1 section-header-buttons w-sm-auto">
                        {/* Could add Filter/Sort buttons if needed */}
                        <button
                            className="ms-auto create-new-btn p-2 rounded-5"
                            onClick={() => {
                                setUserForm(initialForm);
                                setIsEdit(false);
                                setShowForm(prev => !prev);
                            }}
                        >
                            {showForm ? "✖ Close" : "+ Create New"}
                        </button>
                    </div>
                </div>

                {/* Search */}
                <div className="px-4 pb-3">
                    <input
                        className="search-bar rounded-3"
                        type="search"
                        placeholder="Search User"
                    // onChange={...}
                    />
                </div>

                {/* User Table */}
                <div className="px-3 pb-4 table-responsive custom-scroll">
                    <div style={{ overflowY: 'auto', maxHeight: '350px' }}>
                        <table className="table p-2 table-borderless data-table">
                            <thead style={{
                                fontFamily: "Poppins",
                                backgroundColor: "#F8F9FF",
                                borderWidth: "1px 0px 1px 0px",
                                borderStyle: "solid",
                                borderColor: "#0000001A",

                            }}>
                                <tr>
                                    <th className="table-field-bg-color" style={{ paddingLeft: "25px" }}>S. No.</th>
                                    <th className="table-field-bg-color">Email</th>
                                    <th className="table-field-bg-color">Full Name</th>
                                    <th className="table-field-bg-color">Agency Name</th>
                                    <th className="table-field-bg-color">Agency Code</th>
                                    <th className="table-field-bg-color">Phone Number</th>
                                    <th className="table-field-bg-color">Created On</th>
                                    <th className="table-field-bg-color">Last Activity</th>
                                    <th className="table-field-bg-color">Status</th>
                                    <th className="table-field-bg-color text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userList.items && userList.items.length > 0 ? (
                                    userList.items.map((user) => (
                                        <tr key={user.UserId} style={{ height: "10px", borderBottom: "1px solid #0000001A", verticalAlign: "middle", textAlign: "left" }}>
                                            <td style={{ paddingLeft: "25px" }}>{user.rno}</td>
                                            <td>{user.Email}</td>
                                            <td>{user.FullName}</td>
                                            <td>{user.AgencyName}</td>
                                            <td>{user.AgencyCode}</td>
                                            <td>{user.PhoneNumber}</td>
                                            <td>
                                                {user.CreatedOn ? (
                                                    <span className="date text-dark metropolis-semibold">
                                                        {new Date(user.CreatedOn).toLocaleDateString('en-US', {
                                                            weekday: 'short',
                                                            month: 'short',
                                                            year: 'numeric'
                                                        })}
                                                    </span>
                                                ) : ''}
                                            </td>
                                            <td>
                                                {user.LastActivity ? (
                                                    <span className="date text-dark metropolis-semibold">
                                                        {new Date(user.LastActivity).toLocaleString('en-US', {
                                                            weekday: 'short',
                                                            month: 'short',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })}
                                                    </span>
                                                ) : ''}
                                            </td>
                                            <td>
                                                {user.UserStatus === 1 ? (
                                                    <span className="badge bg-success">Active</span>
                                                ) : (
                                                    <span className="badge bg-secondary">Inactive</span>
                                                )}
                                            </td>
                                            <td className="text-center">
                                                <button
                                                    className="btn bg-light btn-sm me-2"
                                                    title="Edit"
                                                    onClick={() => {
                                                        setShowForm(true);
                                                        setIsEdit(true);
                                                        setUserForm({ ...user });
                                                    }}
                                                >
                                                    <img src="./assest/Images/Edit.png" alt="Edit" style={{ width: "1rem" }} />
                                                </button>
                                                {/* <button
                          className="btn bg-light btn-sm"
                          title="Delete"
                          onClick={() => handleDelete(user.UserId)}
                        >
                          <img src="./assest/Images/delete.png" alt="Delete" style={{ width: "1rem" }} />
                        </button> */}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={10} className="text-center">No users found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Pagination */}
            <div className="d-flex justify-content-between align-items-center px-4 py-3">
                <span>
                    Page {Math.min(userList.metaData?.currentPage || userListRequest.PageNo, userList.metaData?.totalPages || 1)} of {userList.metaData?.totalPages || 1}
                </span>
                <div className="d-flex gap-2">
                    <button
                        className="btn btn-light btn-sm"
                        onClick={handlePrev}
                        disabled={userListRequest.PageNo === 1}
                    >
                        Prev
                    </button>
                    <button
                        className="btn btn-light btn-sm"
                        onClick={handleNext}
                        disabled={
                            (userList.metaData?.currentPage || userListRequest.PageNo) === (userList.metaData?.totalPages || 1)
                        }
                    >
                        Next
                    </button>
                </div>
            </div>
        </>
    )
}

export default UserMaster